import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getStaticContent } from '../actions/ContentActions'
import './_app.css'

class App extends Component {
  componentWillMount() {
    this.props.dispatch(getStaticContent())
  }

  constructor(props) {
    super(props)
    this.state = {
      isDrop: false,
      isEti: false,
      origin: ''
    }
  }

  handleDropCard = (drop, origin) => {
    this.setState({
      isDrop: drop,
      isEti: drop,
      origin: origin
    })
  }

  render() {
    const { isDrop, isEti, origin } = this.state

    return (
      <div className="app-root">
        <div className="postcard-logo"></div>
        <div className="rope"></div>

        <div className={`wrapper ${(isDrop) ? 'none' : ''}`}>
          <div className="pin left"></div>
          <div className="pin right"></div>
            <div className="sensor left" onClick={
              () => {
                if(!isDrop) {
                  this.handleDropCard(true, 'right')
                }
              }
            }></div>
            <div className="sensor right" onClick={
              () => {
                if(!isDrop) {
                  this.handleDropCard(true, 'left')
                }
              }
            }></div>

          <div className={`paper-wrap animated ${isDrop ? 'hinge-' : ''}${origin}`}>
            <div className="white-box">
              {this.props.children}
            </div>
          </div>

          <div className="copyrights">
            <div className="logo"></div>
            <span><a href="http://www.atwinta.ru" target="_blank">Создание сайта</a> Атвинта</span> 
          </div>
          <div className="big-present-box"></div>
          <div className="present-boxes"></div>
        </div>  
        <div className={`eti ${(isEti) ? 'show' : ''}`}>
          <div className="refresh-page" onClick={ () => { location.reload() }}>Обновить</div>
        </div>
      </div>
    );
  }
}

export default connect()(App)



// WEBPACK FOOTER //
// ./src/containers/App.js